import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { Badge, Offcanvas, Spinner } from "react-bootstrap";
import { FaClone } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";

const ManageQuery = ({ Show, Hide, query = [], setQuery, updateGlobalCustomEditCheck, buttonLoader }) => {
  const removeQueryParameter = (queryId) => {
    const updatedQuery = query.filter(item => item.id !== queryId);
    setQuery(updatedQuery);
  };

  const duplicateQueryParameter = (queryId) => {
    const itemToDuplicate = query.find(item => item.id === queryId);
    if (!itemToDuplicate) return;
    const newItem = {
      ...itemToDuplicate,
      id: Date.now(),
    };
    const index = query.findIndex(item => item.id === queryId);
    const updatedQuery = [...query];
    updatedQuery.splice(index + 1, 0, newItem);
    setQuery(updatedQuery);
  };


  const handleDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination || source.index === destination.index) return;

    const reordered = [...query];
    const [movedItem] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, movedItem);
    setQuery(reordered);
  };

  const renderBadgeValue = (item) => {
    if (item.type !== "operator") return item.value;
    switch (item.value) {
      case "===": return "=";
      case "/": return "÷";
      case "||": return "OR";
      case "&&": return "AND";
      case "if": return "IF";
      case "then": return "THEN";
      case "else": return "ELSE";
      case "else if": return "ELSE IF";
      default: return item.value;
    }
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end" style={{width: 500}}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          Manage Query
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="tableBody" type="ROW">
            {(provided) => (
              <div ref={provided.innerRef} {...provided.droppableProps}>
                {query.map((item, index) => (
                  <Draggable key={item.id.toString()} draggableId={item.id.toString()} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="hstack justify-content-between mb-2 dnd-item-debug"
                      >
                        <Badge
                          className="br3 text-dark px-3 py-2"
                          title={(item.type === "operator" || item.type === "customValue") ? "" : `Version ${item?.version}`} 
                          bg={item.type === "operator" ? "danger-subtle" : item.type === "function" ? "purple-subtle" : "primary-subtle"}
                        >
                          {renderBadgeValue(item)}
                        </Badge>
                        <div className="hstack gap-2">
                          <button
                            onClick={() => duplicateQueryParameter(item.id)}
                            className="btn border btn-outline-primary br3 py-1"
                            title="Duplicate Query"
                            style={{ fontSize: 12 }}
                          >
                            <FaClone />
                          </button>
                          <button
                            onClick={() => removeQueryParameter(item.id)}
                            className="btn border btn-outline-danger br3 py-1"
                            title="Remove Query"
                            style={{ fontSize: 12 }}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </div>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Offcanvas.Body>
      <div className="text-end border-top p-2 bg-light">
        <button disabled={buttonLoader} onClick={() => updateGlobalCustomEditCheck()} className="updateProfile">
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm"/> Updating...
            </div>
          ) : (
            "Update"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default ManageQuery;
